<app-logo width="130px" [isAnchorForce]="true"></app-logo>

<div class="default-full">
  <div class="default-full__image-overlay">
    <div class="default-full__content shadow">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
